import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss']
})
export class PromptComponent {

  userInput: string = '';
  @Input() isTyping: boolean = false;
  @Output() textChange = new EventEmitter<string>();

  constructor() {}

  sendMessage() {
    if (this.userInput.trim() !== '') {
      this.textChange.emit(this.userInput.trim());
      this.userInput = '';
    }
  }

}
